import React, { useState, useEffect } from 'react';

import useAuth from '~/hooks/useAuth';

import bridge from '~/utils/bridge';
import apiCall, { TEST_URL, LIVE_URL } from '~/utils/apiCall';

import BG from '~/components/background';

import top from './images/top.png';
import terms from './images/terms.png';
import score from './images/score.png';
import bottom from './images/bottom.png';

import { TopWrap, AgreeWrap, LabelWrap, Label, Checkbox, QuestionWrap, ScoreWrap, QuizWrap, BottomWrap } from './styled';

function MainComponent() {
  const [agree, setAgree] = useState(false);
  const [scoreValue, setScoreValue] = useState(0);
  const [quiz, setQuize] = useState(1);
  const [status, setStatus] = useState('');
  const [isSending, setSending] = useState(false);

  const { authKey } = useAuth();

  const agreeText = [
    '1. 개인정보 수집 및 이용 목적 : 당첨자 선정',
    '2. 수집하려는 개인정보의 항목 : 이름, 휴대폰 번호',
    '3. 개인정보의 보유 및 이용 기간 : 당첨자 선정 후 3개월간 보관 후 파기',
    '4. 본 개인정보 제공에 동의를 거부할 권리가 있으며, 동의 거부 시 이벤트 참여가 제한됨',
  ];

  function submit(answer) {
    if (!agree) return alert('본 이벤트는 개인정보 수집/이용및 제공항목에 동의 후 참여가능합니다.');

    setStatus(answer);
    setScoreValue(answer === 'o' ? quiz * 5 : scoreValue);
  }

  function goSign() {
    bridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'openInAppBrowser',
        url: 'https://test-dabang-sign.dabangapp.com/mobile',
      });
    });

    bridge.android(call => {
      console.log('android');
      call.openInAppBrowser('https://test-dabang-sign.dabangapp.com/mobile');
    });
  }

  return (
    <div>
      <BG width={710} height={1920} imgUrl={top} />

      <AgreeWrap>
        <LabelWrap>
          <Label isCheck={agree}>
            <Checkbox type="checkbox" checked={agree} onChange={() => setAgree(prev => !prev)} />
            <p>개인정보 수집/이용 에 대한 동의</p>
          </Label>
        </LabelWrap>
      </AgreeWrap>

      <BG width={710} height={205} imgUrl={terms} />

      <QuestionWrap>
        <ScoreWrap>
          <BG width={668} height={178} imgUrl={require(`./images/${scoreValue}.png`)} />
        </ScoreWrap>

        <BG width={710} height={908} imgUrl={score} />

        <QuizWrap>
          {status === '' ? (
            <BG width={1332} height={1099} imgUrl={require(`./images/q${quiz}.png`)} />
          ) : (
            <BG width={1332} height={1099} imgUrl={require(`./images/q${quiz}_${status}.png`)} />
          )}
        </QuizWrap>
        {status === '' && (
          <>
            <button className="o" onClick={() => submit('o')} />
            <button className="x" onClick={() => submit('x')} />
          </>
        )}
      </QuestionWrap>

      <BottomWrap>
        <BG width={710} height={1070} imgUrl={bottom} />
        <button className="sign" onClick={goSign} />
      </BottomWrap>
    </div>
  );
}

export default MainComponent;
